// Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
//
// This software is the property of WSO2 LLC. and its suppliers, if any.
// Dissemination of any information or reproduction of any material contained
// herein in any form is strictly forbidden, unless permitted by WSO2 expressly.
// You may not alter or remove any copyright or other notice from copies of this content.

import '../styles/Landing.css'
import Header from '../components/header/Header'
import landingBackgroundright from '../images/landing-right.svg'
import landingBackgroundleft from '../images/landing-left.svg'
import { Footer } from "../components/Footer"
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from "@asgardeo/auth-react";
import { useEffect, useState } from 'react';
import { AsgardeoConfig } from "../data/configs/spl-config";
import { DefaultLayout } from '../layouts/DefaultLayout';
import { Box, Stack } from '@mui/material'
import CircularLoading from '../components/Loading'

export const LandingPage = () => {
  const navigate = useNavigate();
  const { state, signIn } = useAuthContext();
  const [openLoading, setOpenLoading] = useState(false);
  const handleLogin = () => {
    setOpenLoading(true);
    signIn();
  };

  useEffect(() => {
    if (!state?.isAuthenticated) {
      return;
    }
    navigate("/support");
  }, [state.isAuthenticated]);

  // If `clientID` is not defined in `config.json`, show a UI warning.
  if (!AsgardeoConfig.clientID) {
    return (
      <DefaultLayout>
        <div className="content">
          <h2>You need to add the correct configuration values to proceed.</h2>
          <p>
            Please open app configuration file using an editor, and
            update the values.
          </p>
        </div>
      </DefaultLayout>
    );
  }

  return (
    <Box >
      <CircularLoading openLoading={openLoading} />
      < Header />
      <Stack direction="row" justifyContent="center" alignItems="center" sx={{ height: "85vh", width: "100vw" }}>
        <Box>
          <img src={landingBackgroundleft} alt="Landing Page Image" className='landing-left' />
        </Box>
        <Box>
          {
            state.isLoading
              ? <div className="content">Loading ...</div>
              : (
                <div className="landing-center-box">
                  <p>Welcome to </p>
                  <img src="/wso2-logo_black.png" alt="WSO2 logo" height="120" style={{ marginBottom: '16px' }} />
                  <h2>Support Portal Lite</h2>
                  <button className='glowing-btn'>
                    <span className='glowing-txt' onClick={handleLogin} >L<span className='faulty-letter'>O</span>GIN</span>
                  </button>
                </div>
              )
          }
        </Box>
        <Box>
          <img src={landingBackgroundright} alt="Landing Page Image" className='landing-right' />
        </Box>
      </Stack>
      <div style={{ position: "absolute", left: "0", bottom: "0", right: "0", background: "aliceblue" }}>
        < Footer />
      </div>
    </Box>
  );
};
